
import { defineComponent } from 'vue';
import AdminNav from '../../components/Admin/AdminNav.vue';
import AdminHead from '../../components/Admin/AdminHead.vue';
export default defineComponent({
  name: 'Admin',
  components: { AdminHead, AdminNav },
});
